module.exports = __webpack_public_path__ + "static/media/nabeel.8f67cbcc.png";